import { useMemo } from 'react'
import { Token } from 'symbiosis-js-sdk'

export function useGetOriginLikeToken(token: Token): Token {
	return useMemo(() => {
		if (!token.isSynthetic || !token.symbol) {
			return token
		}

		let { symbol } = token
		if (symbol.startsWith('s')) {
			symbol = symbol.substring(1)
		}

		const chainId = token.chainFromId ?? token.chainId

		return new Token({ ...token, symbol, chainId })
	}, [token])
}
